<template>
  <router-link
    class="page-logo-link press-scale-down d-flex align-items-center position-relative"
    :to="to"
  >
    <img src="/img/logo.png" aria-roledescription="logo" :alt="appTitle" />

    <span class="page-logo-text mr-1">
      <b>Smart Club</b>
      <b>Manager</b>
    </span>
  </router-link>
</template>

<script>
import { mapState } from 'vuex';

// @vuese
// Logo w nagłówku
// @group Layout
export default {
  props: {
    // Konfiguracja dla routingu
    to: {
      type: [Object, String]
    }
  },
  computed: {
    ...mapState({
      appTitle: state => state.system.appTitle
    })
  }
};
</script>